export default __webpack_public_path__ + "static/media/facebook-4-512-round.f0cf0dbd.png";